import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { FileOption } from '../../prompt-details/models/file.option.interface';
import { CallParkingLotFilterOptions } from '../models/call-parking-filter-option';
import { CallParkingLotRegisterListItem } from '../models/call-parkinglot-register-results.model';

const area = 'Call Parking Register';
export const callParkingLotRegisterAdapterActions = createRegisterActions<CallParkingLotRegisterListItem>(area);

export const createCallParkingLots = createAction(`[${area}] Create CallLogs`);

export const openDialog = createAction('[Call ParkingLots] Open Dialog', props<{ callLogs: CallParkingLotRegisterListItem }>());

export const listenToRecording = createAction('[Call ParkingLots] Listen to recording', props<{files: FileOption[]}>());

export const callParkingLotsRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: CallParkingLotFilterOptions[] }>()
);
